import { ACTION, METHODS, MODAL_TITLE, MODAL_TYPE, routes } from '../../../utils/constants'
import Trade from '../classes/Trade'
import { webSocketWorkerEvent } from '../../../services'
import { useDispatch, useSelector } from 'react-redux'
import { setModal } from '../../../redux/slices/Modal/modalSlice'
import axios from 'axios'
import { cleanEmptyField } from '../../../helper'
import { useCallback } from 'react'
import dayjs from 'dayjs'

const useToolBarSetting = ({
  gridRef,
  tradesGiveUp,
  dealsGroup,
  tradesGroup,
  tradesConversion,
  dealsNotSentToPb,
  dealsGiveUpGroup,
  dealTradesGroup,
  filters,
  tradeBlotterDataAgGrid,
  unAllocatedDeals,
  skeltonLoader,
  dispatchNotification,
  cleanCheckBoxState,
  setFilters,
  setPage,
  initialFilterState
}) => {
  const dispatch = useDispatch()
  const token = useSelector(state => state.auth.token)

  const handelGroupButtonRender = () => {
    return (
      Object.keys(dealsNotSentToPb).length === 0 ||
      (Object.keys(dealsNotSentToPb).length === 1 && Object.keys(tradesGroup).length >= 1)
    )
  }

  const handelDealTradeGiveUp = () => {
    const deals_id = Object.keys(dealsGiveUpGroup)
    const trades_id = Object.keys(tradesGiveUp)
    webSocketWorkerEvent.sendEvent({
      type: 'give_up_deals',
      data: {
        deals_id,
        trades_id
      }
    })
  }

  const handelTradeDealDelete = () => {
    const deals_id = Object.keys(dealsGroup)
    const trades_id = Object.keys(tradesGroup)
    const conversion_trades_id = Object.keys(tradesConversion)
    const trades_give_up = Object.keys(tradesGiveUp)
    const data = {
      trades_id: trades_id.concat(conversion_trades_id, trades_give_up),
      deals_id
    }

    cleanEmptyField(data)

    webSocketWorkerEvent.sendEvent({
      type: 'delete_trades_or_deals',
      data: data
    })
  }

  const cleanFilters = useCallback(() => {
    skeltonLoader()
    cleanCheckBoxState()
    setFilters(initialFilterState)
    setPage(1)
    gridRef.current.api.setFilterModel(null)
    const request = { type: 'get_trade_blotter', data: {} }
    webSocketWorkerEvent.sendEvent(request)
  }, [cleanCheckBoxState, gridRef, initialFilterState, setFilters])

  const handelGroupTrade = () => {
    let trades, deal
    const ERROR = 'error'

    trades = Object.values(tradesGroup)
    const symbols = Array.from(new Set(trades.map(({ symbol }) => symbol)))
    deal = Object.values(dealsNotSentToPb)[0]
    if (deal) {
      trades = trades.concat(deal.children)
    }
    if (deal && deal.symbol && !symbols.includes(deal.symbol)) {
      dispatchNotification(`Can't Group Trades To A Deal If Not Same Symbol`, ERROR)
    }
    if (trades.length > 1) {
      if (symbols.length !== 1) {
        dispatchNotification(`Can't Group Trades If Not Same Symbol`, ERROR)
        return
      }
      const directions = trades.map(({ direction }) => direction)
      const removeDuplicateDirections = new Set(directions)

      if (removeDuplicateDirections.size === 1) {
        const tradesId = Object.keys(tradesGroup).map(tradeId => +tradeId)
        webSocketWorkerEvent.sendEvent({
          type: 'group_trades',
          data: {
            trades_id: tradesId,
            deal_id: deal?.id
          }
        })
        return
      }

      const sides = trades.map(({ side }) => side)
      const removeDuplicateSides = new Set(sides)
      if (removeDuplicateSides.size === 1) {
        dispatchNotification(`Can't Group Trades If Sides Are The Same`, ERROR)
        return
      }
    }
    if (deal && deal.symbol) {
      if (!symbols.includes(deal.symbol)) {
        dispatchNotification(`Can't Group Trades To A Deal If Not Same Symbol`, ERROR)
        return
      }
    }

    const tradesId = Object.keys(tradesGroup).map(tradeId => +tradeId)
    webSocketWorkerEvent.sendEvent({
      type: 'group_trades',
      data: {
        trades_id: tradesId,
        deal_id: deal?.id
      }
    })
  }

  const handelUnAllocateDeal = async () => {
    const dealsKey = Object.keys(unAllocatedDeals)
    dispatch(
      setModal({
        type: MODAL_TYPE.ALLOCATE_BLOCK,
        title: MODAL_TITLE.ALLOCATE_BLOCK,
        action: ACTION.UPDATE,
        data: { deals_id: dealsKey },
        method: METHODS.PUT,
        isOpen: true
      })
    )
  }

  const handelAmendTradeLogic = async (id, body, disabled) => {
    const { premium_currency, option_payment_currency, type, payout_currency } = body
    const currencies = [premium_currency, option_payment_currency, payout_currency]

    try {
      const fetchCurrencyData = async currency => {
        if (!currency) return null
        const url = `${process.env.REACT_APP_SERVER_URL}${routes.currency}/${currency}`
        const response = await axios.get(url, { headers: { Authorization: token } })
        return response.data
      }

      const [premiumData, optionData, payoutCurrencyData] = await Promise.all(
        currencies.map(fetchCurrencyData)
      )

      const fetchTradeTypeData = async tradeType => {
        if (!tradeType) return null
        const url = `${process.env.REACT_APP_SERVER_URL}${routes.tradeType}/${tradeType}`
        const response = await axios.get(url, { headers: { Authorization: token } })
        return response.data
      }

      const typeInfo = await fetchTradeTypeData(body.type)

      const data = {
        ...body,
        trade_type: type.includes('Client') ? 'Client' : 'Market',
        premium_currency: premiumData,
        currency_pair: body.base_currency.concat(body.counter_currency),
        payout_currency: payoutCurrencyData,
        option_payment_currency: optionData,
        type: typeInfo,
        id
      }

      const url = `${window.location.origin}/trade`
      const popup = window.open(
        url,
        'Edit Trade', // window name
        'width=600,height=800,top=100,left=100,toolbar=no,menubar=no,scrollbars=no,resizable=no'
      )
      const checkPopupLoaded = setInterval(() => {
        if (popup.document && popup.document.readyState === 'complete') {
          clearInterval(checkPopupLoaded)
          popup.postMessage(
            {
              type: MODAL_TYPE.TRADE,
              title: MODAL_TITLE.EDIT_TRADE,
              action: ACTION.UPDATE,
              disabled: disabled,
              data,
              method: METHODS.PUT
            },
            window.origin
          )
        }
      }, 500)
    } catch (error) {
      console.log(error)
    }
  }

  const handelUnGroupDeals = async () => {
    const deals_id = Object.keys(dealsNotSentToPb).map(deal => Number(deal))
    webSocketWorkerEvent.sendEvent({
      type: 'un_group_deals',
      data: {
        deals_id
      }
    })
  }

  const handelAmendTrade = async () => {
    const trade = Object.entries(tradesGroup)[0]
    const dealTrade = Object.entries(dealTradesGroup)[0]
    const tradeGiveUp = Object.entries(tradesGiveUp)[0]
    const tradeConversion = Object.entries(tradesConversion)[0]
    if (trade) {
      const [tradeId, tradeBody] = trade
      handelAmendTradeLogic(tradeId, tradeBody, false)
    } else if (dealTrade) {
      const [tradeId, tradeBody] = dealTrade
      handelAmendTradeLogic(tradeId, tradeBody, true)
    } else if (tradeGiveUp) {
      const [tradeId, tradeBody] = tradeGiveUp
      handelAmendTradeLogic(tradeId, tradeBody, false)
    } else if (tradeConversion) {
      const [tradeId, tradeBody] = tradeConversion
      handelAmendTradeLogic(tradeId, tradeBody, false)
    }
  }

  const csvExport = () => {
    const csvRows = []
    const data = tradeBlotterDataAgGrid.current
      .filter(element => {
        const { staging_status, allocation_status, status, children } = element
        return (
          Array.isArray(children) &&
          staging_status === 'Live' &&
          ['NEW', null].includes(status) &&
          allocation_status === 'Allocated'
        )
      })
      .map(({ children }) => children)
      .flat()
      .map(trade => new Trade(trade))
    if (!data.length || !data) {
      dispatchNotification('no data to export', 'error')
      return
    }
    const headers = Object.keys(data[0])
    csvRows.push(headers.join(','))
    for (const row of data) {
      const values = headers.map(header => `"${row[header]}"`)
      csvRows.push(values.join(','))
    }
    const csvString = csvRows.join('\n')
    const blob = new Blob([csvString], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `trade blotter ${dayjs().format('YYYY-MMM-DD HH:mm:ss')}.csv`
    a.click()
  }

  const handelDeleteTradingAccountShortnameFilter = () => {
    const copyFilters = JSON.parse(JSON.stringify(filters))
    cleanEmptyField(copyFilters)
    skeltonLoader()
    delete copyFilters.trading_account_shortname
    webSocketWorkerEvent.sendEvent({
      type: 'get_trade_blotter',
      data: copyFilters
    })
    setFilters(prev => ({ ...prev, trading_account_shortname: '' }))
  }

  return {
    handelTradeDealDelete,
    handelGroupButtonRender,
    handelDealTradeGiveUp,
    handelUnGroupDeals,
    handelAmendTrade,
    handelGroupTrade,
    handelUnAllocateDeal,
    cleanFilters,
    handelDeleteTradingAccountShortnameFilter,
    csvExport
  }
}

export default useToolBarSetting
